import styled from 'styled-components';

import { AddCollaboratorIcon } from '@genially/icons';

export const Icon = styled(AddCollaboratorIcon)(({ theme: { size } }) => ({
  height: size.units(2),
  width: size.units(2),
}));
